class Product{constructor(){this.acc=[],this.container=document.querySelector(".m-main-product"),MinimogTheme.CompareProduct&&MinimogTheme.CompareProduct.setCompareButtonsState(),MinimogTheme.Wishlist&&MinimogTheme.Wishlist.setWishlistButtonsState(),this.addRecentViewedProduct(),addEventDelegate({context:this.container,selector:(window.__minimog_review_selector||"")+".m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview",handler:e=>{const t=e.target.closest(".m-product-collapsible").dataset.index;setTimeout((()=>{this.acc[Number(t)].setContentHeight()}),300)},capture:!0})}addRecentViewedProduct(){const e=getCookie("m-recent-viewed-products");let t=e?JSON.parse(e):[];-1===t.indexOf(MinimogSettings.productHandle)&&(t.unshift(MinimogSettings.productHandle),t=t.slice(0,20),setCookie("m-recent-viewed-products",JSON.stringify(t)))}}


(function() {
  'use strict';
  
  // Configuration
  const config = {
    updateInterval: 4000,
    entranceDelay: 200,
    exitDelay: 150,
    animationDuration: 800
  };
  
  // Detect website language
  function detectLanguage() {
    // Check HTML lang attribute
    const htmlLang = document.documentElement.lang || '';
    if (htmlLang.toLowerCase().includes('ar')) return 'ar';
    if (htmlLang.toLowerCase().includes('en')) return 'en';
    
    // Check Shopify locale
    if (window.Shopify && window.Shopify.locale) {
      if (window.Shopify.locale.toLowerCase().includes('ar')) return 'ar';
      if (window.Shopify.locale.toLowerCase().includes('en')) return 'en';
    }
    
    // Check direction (RTL = Arabic)
    const direction = document.documentElement.dir || document.body.dir || '';
    if (direction.toLowerCase() === 'rtl') return 'ar';
    
    // Default to English
    return 'en';
  }
  
  // Phrases in both languages
  const phrasesData = {
    ar: [
      'شحن سريع',
      'تغليف أنيق ومحكم',
      'كميات محدودة',
      'جاهز للشحن الفوري',
      'ضمان جودة المنتج',
      'موثوق آلاف العملاء',
      'منتج موثوق',
      'جودة مضمونة',
      'معتمد من خبراء التجميل',
      'تقييمات عالية',
      'الأكثر مبيعا',
      'عناية فاخرة بمعايير عالمية',
      'معدل إعادة شراء مرتفع',
      'طلب مرتفع دوليًا',
      'ترند في العناية بالبشرة',
      'استبدال مجاني',
      'مرتجعات سهلة'
    ],
    en: [
      'Fast Shipping',
      'Elegant & Secure Packaging',
      'Limited Quantities',
      'Ready for Immediate Shipping',
      'Product Quality Guarantee',
      'Trusted by Thousands',
      'Trusted Product',
      'Guaranteed Quality',
      'Approved by Beauty Experts',
      'High Ratings',
      'Best Seller',
      'Luxury Care with Global Standards',
      'High Repurchase Rate',
      'High International Demand',
      'Trending in Skincare',
      'Free Replacement',
      'Easy Returns'
    ]
  };
  
  // Get phrases based on detected language
  const currentLang = detectLanguage();
  const phrases = phrasesData[currentLang];
  
  const animations = ['fade-in', 'slide-in', 'bounce-in'];
  const exitAnimations = ['fade-out', 'slide-out', 'bounce-out'];
  
  const phrasesWrapper = document.getElementById('phrasesWrapper');
  let usedPhrases = [];
  
  // Fisher-Yates shuffle algorithm
  function shuffleArray(array) {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  }
  
  // Get 3 random unique phrases
  function getRandomPhrases() {
    if (usedPhrases.length >= phrases.length - 2) {
      usedPhrases = [];
    }
    
    const availablePhrases = phrases.filter(p => !usedPhrases.includes(p));
    const shuffled = shuffleArray(availablePhrases);
    const selected = shuffled.slice(0, 3);
    
    usedPhrases.push(...selected);
    return selected;
  }
  
  // Get random animation
  function getRandomAnimation() {
    return animations[Math.floor(Math.random() * animations.length)];
  }
  
  function getRandomExitAnimation() {
    return exitAnimations[Math.floor(Math.random() * exitAnimations.length)];
  }
  
  // Create phrase element
  function createPhraseElement(text, animation, delay = 0) {
    const phraseBox = document.createElement('div');
    phraseBox.className = 'phrase-box';
    
    const phraseText = document.createElement('div');
    phraseText.className = 'phrase-text';
    phraseText.textContent = text;
    
    phraseBox.appendChild(phraseText);
    
    setTimeout(() => {
      phraseBox.classList.add(animation);
    }, delay);
    
    return phraseBox;
  }
  
  // Remove phrases with animation
  function removePhrases() {
    return new Promise((resolve) => {
      const currentBoxes = phrasesWrapper.querySelectorAll('.phrase-box');
      
      if (currentBoxes.length === 0) {
        resolve();
        return;
      }
      
      currentBoxes.forEach((box, index) => {
        const exitAnim = getRandomExitAnimation();
        setTimeout(() => {
          box.classList.add(exitAnim);
        }, index * config.exitDelay);
      });
      
      setTimeout(() => {
        phrasesWrapper.innerHTML = '';
        resolve();
      }, config.animationDuration);
    });
  }
  
  // Update phrases
  async function updatePhrases() {
    await removePhrases();
    
    const newPhrases = getRandomPhrases();
    
    newPhrases.forEach((phrase, index) => {
      const animation = getRandomAnimation();
      const phraseElement = createPhraseElement(phrase, animation, index * config.entranceDelay);
      phrasesWrapper.appendChild(phraseElement);
    });
  }
  
  // Initialize
  updatePhrases();
  setInterval(updatePhrases, config.updateInterval);
})();